import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppRouterService {
  private readonly router = inject(Router);
  private fleetingParams: any = {};
  private previousUrl: string | null = null;
  private urlBeforeNavigation: string | null = null;

  constructor() {
    this.setupNavigationTracking();
  }

  getParam(key: string) {
    if (!this.fleetingParams[key]) {
      return undefined;
    }

    const paramValue = this.fleetingParams[key];

    delete this.fleetingParams[key];
    return paramValue;
  }

  async goToAuctionRoom(params: AppRouterParam[] = []) {
    this.setParams(params);
    await this.router.navigate(['/auction']);
  }

  async goToHome(params: AppRouterParam[] = []) {
    this.setParams(params);
    await this.router.navigate(['/room']);
  }

  goToLogin(params: AppRouterParam[] = []) {
    this.setParams(params);
    this.router.navigate(['/login']);
  }

  goToLots(
    params: AppRouterParam[] = []
  ) {
    this.setParams(params);
    return this.router.navigate(['/lots']);
  }

  goToAnticipatedLots(auctionId: string) {
    const params = [{ key: 'auctionId', value: auctionId }];
    this.setParams(params);
    this.router.navigate(['/lots/anticipated']);
  }

  goToScheduledBids(params: AppRouterParam[] = []) {
    this.setParams(params);
    this.router.navigate(['/lots/scheduled']);
  }

  goBack(): void {    
    if (this.previousUrl && this.previousUrl !== this.router.url) {
      this.router.navigateByUrl(this.previousUrl);
    } else {
      this.goToAuctionRoom();
    }
  }

  goToWithoutEvent(params: AppRouterParam[] = []) {
    this.setParams(params);
    this.router.navigate(['/no-event']);
  }

  getLoginUrl() {
    return this.router.parseUrl('/login');
  }

  getAuctionRoomUrl() {
    return this.router.parseUrl('/auction');
  }

  getWithoutEventUrl() {
    return this.router.parseUrl('/no-event');
  }

  private setParams(params: AppRouterParam[]) {
    params.forEach((param) => (this.fleetingParams[param.key] = param.value));
  }

  private setupNavigationTracking(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Capturar la URL actual antes de que el router la reemplace,
        // para que previousUrl refleje la ruta de origen y no la de destino.
        this.urlBeforeNavigation = this.router.url;
      } else if (event instanceof NavigationEnd) {
        // Solo guardar la URL previa si no es la página de lotes anticipados
        // para evitar bucles de navegación
        if (!event.url.includes('/lots/anticipated')) {
          this.previousUrl = this.urlBeforeNavigation;
        }
      }
    });
  }
}

export interface AppRouterParam {
  key: string;
  value: any;
}
